export const CONFIRMED_CREATE_REGISTER_ACTION = "CONFIRMED_CREATE_REGISTER_ACTION";
export const FAILED_CREATE_REGISTER_ACTION = "FAILED_CREATE_REGISTER_ACTION";